import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://www.shatranj.live';

// All supported language codes (matches translations.js LANGUAGES)
const LANG_CODES = ['en', 'zh', 'hi', 'es', 'fr', 'ar', 'bn', 'pt', 'ru', 'ur'];

const HreflangTags = () => {
  const location = useLocation();

  useEffect(() => {
    // Remove any existing hreflang tags to avoid duplicates
    document.head.querySelectorAll('link[hreflang]').forEach((el) => el.remove());

    const path = location.pathname;
    const pageUrl = `${BASE_URL}${path}`;

    const add = (hreflang, href) => {
      const link = document.createElement('link');
      link.rel = 'alternate';
      link.hreflang = hreflang;
      link.href = href;
      document.head.appendChild(link);
    };

    // x-default always points to the root English page
    add('x-default', `${BASE_URL}/`);

    // One hreflang per language, using ?lang=xx as the differentiator
    LANG_CODES.forEach((lang) => {
      const href = lang === 'en' ? pageUrl : `${pageUrl}?lang=${lang}`;
      add(lang, href);
    });

    // Regional English variants only on applicable pages
    if (path === '/' || path === '/india') {
      add('en-IN', `${BASE_URL}/india`);
    }
    if (path === '/' || path === '/us') {
      add('en-US', `${BASE_URL}/us`);
    }
  }, [location.pathname]);

  return null;
};

export default HreflangTags;
